export default {
  extra: { platform: 'web' }
};
